angular.module('bmsApp.sm')
	.factory('SMInvoiceSvc', [
		'$q',
		'CRUDSvc',
		function ($q,
				  CRUDSvc) {

			return {
				save: function (params) {
					return CRUDSvc.post('api/sm/invoice/save', params);
				}

			};

		}
	]);
